export default __webpack_public_path__ + "static/media/11AW1FEB66.1a94bba2.jpg";